import { createReducer, Action, on } from '@ngrx/store';

import { FormulaListActions } from './formula-list.actions';
import { FormulaListState } from './formula-list.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: FormulaListState = {
  loading: false,
  sort: { active: 'displayName', direction: 'asc' },
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      FormulaListActions.LoadList,
      (state): FormulaListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      FormulaListActions.LoadListSuccess,
      (state, action): FormulaListState => ({ ...state, loading: false, list: action.list })
    ),

    on(
      FormulaListActions.DeleteFormulaFail,
      FormulaListActions.LoadListFail,
      FormulaListActions.SaveFormulaDetailsFail,
      FormulaListActions.CreateFormulaFail,
      (state, action): FormulaListState => ({ ...state, loading: false, error: action.error })
    ),
    on(
      FormulaListActions.DeleteFormula,
      (state): FormulaListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      FormulaListActions.DeleteFormulaSuccess,
      (state, action): FormulaListState => ({
        ...state,
        loading: false,
        list: state.list?.filter((f) => f.id !== action.id),
      })
    ),
    on(
      FormulaListActions.CreateFormulaSuccess,
      (state, action): FormulaListState => ({
        ...state,
        list: [...(state.list || []), action.formula],
      })
    ),
    on(FormulaListActions.Sort, (state, action) => ({ ...state, sort: action.sort })),
    on(FormulaListActions.Search, (state, action) => ({ ...state, search: action.search })),
    on(FormulaListActions.Filter, (state, action) => ({ ...state, filter: action.filter })),
    on(FormulaListActions.SaveFormulaDetailsSuccess, (state, action) => ({
      ...state,
      list: state.list?.map((f) => (f.id === action.formula.id ? action.formula : f)),
    }))
  )
);

export function reducer(state: FormulaListState | undefined, action: Action) {
  return featureReducer(state, action);
}
